import script from "./ColorfulTabs.vue?vue&type=script&lang=ts&setup=true"
export * from "./ColorfulTabs.vue?vue&type=script&lang=ts&setup=true"

import "./ColorfulTabs.vue?vue&type=style&index=0&id=3dbf82b8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dbf82b8"]])

export default __exports__